export const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_TREE_OBJ':
            return {
                ...state,
                treeObj: action.payload,
            };
        case 'SET_CURRENT_ITEMS':
            let items;
            if (!action.payload) {
                items = [];
            } else {
                items = action.payload;
            }
            return {
                ...state,
                currentItems: items,
            };
        case 'SET_CURRENT_PATH':
            return {
                ...state,
                currentPath: action.payload,
            };
        case 'SET_BUSY_STATE':
            return {
                ...state,
                busy: action.payload,
            };
        case 'SET_USERS':
            return {
                ...state,
                users: action.payload,
            };
        case 'SET_SELECTED_FILE':
            return {
                ...state,
                selectedFile: action.payload,
            };
        case 'REFRESH':
            return {
                ...state,
                refresh: !state.refresh,
            };
        case 'SEARCH_REDIRECT':
            return {
                ...state,
                rememberSelectedFile: action.payload,
            };

        case 'SET_ACCESSTOKEN':
            return {
                ...state,
                accessToken: action.payload,
            };
        case 'SET_SELECTED_USER':
            return {
                ...state,
                selectedUser: action.payload,
            };
        case 'SET_ANALYTICS_FILE':
            return {
                ...state,
                analyticsFile: action.payload,
            };
        default:
            return state;
    }
};

export const initialState = {
    treeObj: null,
    currentItems: [],
    currentPath: [],
    busy: false,
    users: [],
    selectedFile: { name: null },
    refresh: false,
    accessToken: null,
    selectedUser: { username: null },
    rememberSelectedFile: false,
    analyticsFile: undefined
};
